import { createAction } from 'redux-actions';
import { createSuccessAction, createFailureAction } from 'utilities/request';

export const authLogin = createAction('AUTH/LOGIN');

export const authLogout = createAction('AUTH/LOGOUT');

export const authSet = createAction('AUTH/SET');

export const authSetupUser = createAction('AUTH/SETUP_USER');

export const authUnauthorized = createAction('AUTH/UNAUTHORIZED');

export const requestAuthLogin = createAction('REQUEST/AUTH/LOGIN');
export const requestAuthLoginSuccess = createSuccessAction(requestAuthLogin);
export const requestAuthLoginFailure = createFailureAction(requestAuthLogin);
